import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=622970e7&scoped=true"
import script from "./kaoshi.vue?vue&type=script&lang=js"
export * from "./kaoshi.vue?vue&type=script&lang=js"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=622970e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622970e7",
  null
  
)

export default component.exports